<template>
  <section class="merchant-tree">
    <p class="title">商户</p>
    <template>
      <div v-if="merchantList.length <= 0" class="no-data">暂无数据</div>
      <div
        v-else
        v-for="merchant in merchantList"
        :key="merchant.id"
        class="merchant-list"
        @click="() => onNodeClick(merchant)"
      >
        <span v-bind:class="['normal', merchant.checked ? 'is-gray' : '']">{{
          merchant.name
        }}</span>
      </div>
    </template>
  </section>
</template>
<script>
import { getPosList } from "@/api/url";
export default {
  name: "merchant-tree",
  props: ["groupId"],
  data() {
    return {
      merchantList: [],
    };
  },
  mounted() {},
  watch: {
    groupId: function(newVal, oldVal) {
      this.getMerchantList();
    },
  },
  methods: {
    getMerchantList() {
      this.$get(getPosList(), {
        parkingId: this.groupId,
        page: 1,
        limit: 500,
      }).then((data) => {
        if (data?.status != 200) return;
        this.merchantList =
          data?.data?.rows ??
          [].map((merchant) => {
            merchant.checked = false;
            return merchant;
          });
      });
    },
    onNodeClick(node) {
      
      const currentMerchantList = JSON.parse(JSON.stringify(this.merchantList));
      this.merchantList = currentMerchantList.map((merchant) => {
       
        merchant.id === node.id
          ? (merchant.checked = true)
          : (merchant.checked = false);
        return merchant;
      });

      this.$emit("merchantTreeCallback", node);
    },
  },
};
</script>
<style lang="scss" scoped>
.merchant-tree {
  width: 120px;
  padding: 50px 5px 5px 10px;
  box-sizing: border-box;
  border-right: 10px solid #eff2f7;
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
.merchant-list {
  .normal {
    display: inline-block;
    width: 100%;
    padding: 2px 10px;
    margin: 5px;
    cursor: pointer;
  }
}
.is-gray {
  background: #ddd;
}
</style>
